module.exports = __webpack_public_path__ + "static/media/jihao@3x.8b7d1106.png";